
interface BlogDetailHeroProps {
  data: {
    title: string;
    category: string;
    date: string;
    readTime: string;
    author: string;
    image: string;
  };
}

const BlogDetailHero = ({ data }: BlogDetailHeroProps) => {
  return (
    <section className="pt-32 pb-12 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Category Badge */}
        <div className="flex items-center justify-center mb-6">
          <span className="px-4 py-2 bg-[#007dff]/10 rounded-full font-poppins text-sm font-semibold text-[#007dff]">
            {data.category}
          </span>
        </div>

        {/* Title */}
        <h1 className="font-poppins font-bold text-3xl sm:text-4xl lg:text-5xl text-gray-900 mb-8 text-center leading-tight">
          {data.title}
        </h1>

        {/* Meta Info */}
        <div className="flex items-center justify-center gap-6 mb-10 text-sm text-gray-600 font-inter flex-wrap">
          <span className="flex items-center gap-2">
            <i className="ri-user-line text-[#007dff]"></i>
            {data.author}
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-calendar-line text-[#007dff]"></i>
            {data.date}
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-time-line text-[#007dff]"></i>
            {data.readTime} okuma
          </span>
        </div>

        {/* Featured Image */}
        <div className="relative w-full h-96 rounded-2xl overflow-hidden">
          <img
            src={data.image}
            alt={data.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
};

export default BlogDetailHero;
